import React from 'react';
import { Section, SectionTitle } from '../Section';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { FaqAccordion } from '../FaqAccordion';
import { steps } from '../../data/landing';
export function UrgencySection() {
  return <Section tone="wine" className="text-center" data-id="element-50" data-mp="1u5mshsmhhxkc">
      <SectionTitle data-id="element-51" data-mp="1u4ttjdtroccr">La clase empieza el jueves 29 de octubre.</SectionTitle>
      <div className="mt-12" data-id="element-52" data-mp="1p71ttxmvrly0">
        <Countdown data-id="element-53" data-mp="1p83f0uxm1otg" />
      </div>
      <p className="mx-auto mt-8 max-w-[560px] text-sm leading-relaxed text-ivory/75" data-id="element-54" data-mp="1p47882s4rv30">
        México 6 pm · Colombia y Perú 7 pm · Venezuela y Miami 8 pm · Argentina y Chile 9 pm · España 1 am del viernes 30
      </p>
      <p className="mx-auto mt-10 max-w-[560px] text-[17px] leading-relaxed text-ivory md:text-lg" data-id="element-55" data-mp="1b70s6fyskahh">
        Solo los primeros 100 entran en vivo. Cuando se completan, se cierra la venta. No se abren más lugares.
      </p>
      <div className="mt-12" data-id="element-56" data-mp="35kii29mo5jfo">
        <CTAButton data-id="element-57" data-mp="35lbjcv2uzgqf" />
      </div>
    </Section>;
}
export function StepsSection() {
  return <Section tone="ink" data-id="element-58" data-mp="1hyt6p6yw2ms2">
      <SectionTitle data-id="element-59" data-mp="1i2qrdx147me2">Así de simple</SectionTitle>
      <ol className="mt-12" data-id="element-60" data-mp="1m30v131fq0pr">
        {steps.map((step, i) => <li key={step} className="flex gap-6 border-b border-gold/20 py-7 first:pt-0 last:border-b-0" data-id="element-61" data-mp="1826o6ou1c7t7" data-mpi={i}>
            <span className="w-10 shrink-0 font-serif text-6xl font-medium leading-[0.85] text-gold" data-id="element-62" data-mp="1d11ba2z1cij4">{i + 1}</span>
            <p className="pt-1 text-[17px] leading-relaxed text-ivory md:text-lg" data-id="element-63" data-mp="20qlwytmkptw3">{step}</p>
          </li>)}
      </ol>
    </Section>;
}
export function FaqSection() {
  return <Section tone="wine" data-id="element-64" data-mp="1r1kjpb7exqlt">
      <SectionTitle data-id="element-65" data-mp="1r00zj9imyver">Preguntas frecuentes</SectionTitle>
      <div className="mt-12" data-id="element-66" data-mp="1w05ir7axi48o">
        <FaqAccordion data-id="element-67" data-mp="1vzdnjxl8u8ix" />
      </div>
    </Section>;
}
export function FinalSection() {
  return <Section tone="ink" className="text-center" data-id="element-68" data-mp="2jpgajzaawoao">
      <h2 className="font-serif text-[2.9rem] font-medium leading-[1.05] text-ivory md:text-[4rem]" data-id="element-69" data-mp="2jnn7sv2t6o7y">
        Sigue improvisando… <em className="italic text-gold" data-id="element-70" data-mp="2yc6p42d1cde7">o vuélvete inolvidable.</em>
      </h2>
      <p className="mx-auto mt-8 max-w-[580px] text-[17px] leading-relaxed text-ivory/90 md:text-lg" data-id="element-71" data-mp="2ya2njr2lzqh3">
        Cuatro módulos, una guía para seguir practicando y la grabación por 1 año. Por $17, con garantía de 7 días. El
        único riesgo es quedarte afuera de los 100.
      </p>
      <div className="mt-12" data-id="element-72" data-mp="2kce32kcgelck">
        <CTAButton data-id="element-73" data-mp="2fdkn8l9p2i98" />
      </div>
      <p className="mx-auto mt-6 max-w-[480px] text-sm leading-relaxed text-ivory/65" data-id="element-74" data-mp="2femb5qbt6z8d">
        Solo los primeros 100 entran en vivo. Los primeros 20 reciben el Reto Inolvidable.
      </p>
    </Section>;
}
export function Footer() {
  return <footer className="border-t border-gold/20 bg-ink px-6 pb-32 pt-12 text-center md:pb-12" data-id="element-75" data-mp="25lopxcffmw62">
      <div className="mx-auto max-w-[720px] space-y-3 text-sm leading-relaxed text-ivory/60" data-id="element-76" data-mp="20mlijlbzcdux">
        <p data-id="element-77" data-mp="1wma26kqngzp9">Contenido de educación sexual para mayores de 18 años. No sustituye la atención médica ni sexológica.</p>
        <p data-id="element-78" data-mp="1rqcka9zqnlad">© 2026 Beatriz Espina · Términos · Privacidad</p>
      </div>
    </footer>;
}